export function isProductionBuild() {
  return process.env.NODE_ENV === 'production';
}

function isProductionHost() {
  return /^(\w*\.)?squareup.com/.test(window.location.host);
}

function isLocalHost() {
  return /^(localhost|127\.0\.0\.1)(:\d+)?$/.test(window.location.host);
}

function getEnvName() {
  if (isProductionHost()) {
    return 'production';
  }

  return isLocalHost() ? 'development' : 'staging';
}

export function environment() {
  return {
    isProduction: isProductionHost(),
    name: getEnvName(),
  };
}

/**
 * Env-aware logout url.
 */
export const logoutUrl = (returnTo?: string) =>
  isProductionBuild()
    ? `/logout?return_to=${returnTo || '/signin'}`
    : `/logout?app=buyer-portal&return_to=${
        returnTo || '/signin?app=buyer-portal'
      }`;
